import React from 'react';
import './SelectWithChoice.scss'
import cn from 'classnames'

interface IProps {
    options: { key: string, value: string }[]
    onSelectOption: (key: string) => void
    currentInput: string
    onInputChange: (val: string) => void
    optionsUp?: boolean
    disabled?: boolean
    innerInputRef?: React.RefObject<HTMLInputElement>;
}

interface IState {
    showOptions: boolean;
    keySelectedIndex: number;
}

export default class SelectWithChoice extends React.Component<IProps, IState>{
    private optionsRef: React.RefObject<HTMLDivElement>;
    private wrapperRef: React.RefObject<HTMLDivElement>;

    constructor(props: IProps) {
        super(props);
        this.state = {
            showOptions: false,
            keySelectedIndex: -1
        }
        this.wrapperRef = React.createRef();
        this.optionsRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount(): void {
        document.addEventListener("mousedown", this.handleClickOutside, { capture: false });
    }

    componentWillUnmount(): void {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    private ReturnFocus() {
        !!this.props.innerInputRef && !!this.props.innerInputRef.current && this.props.innerInputRef.current.focus();
    }

    render(): React.ReactNode {
        return <div ref={this.wrapperRef} className='fias_body'>
            {this.props.optionsUp && this.state.showOptions && <div className='fias__options' ref={this.optionsRef}>
                {this.props.options.map((o, i) =>
                    <div className={cn('fias__option', { 'selected': i == this.state.keySelectedIndex })} onClick={(e) => { this.props.onSelectOption(o.key); e.stopPropagation(); this.ReturnFocus(); }} id={`option_${i}`} key={o.key}>{o.value}</div>)}
            </div>}
            <input
                ref={this.props.innerInputRef}
                onFocus={() => { this.setState({ showOptions: true }); }}
                value={this.props.currentInput}
                onChange={(e) => { this.props.onInputChange(e.target.value); this.setState({ keySelectedIndex: -1 }) }}
                onKeyDown={(e) => this.checkKeyDown(e.key)}
                disabled={this.props.disabled}
            />
            {!this.props.optionsUp && this.state.showOptions && <div className='fias__options' ref={this.optionsRef}>
                {this.props.options.map((o, i) =>
                    <div className={cn('fias__option', { 'selected': i == this.state.keySelectedIndex })} onClick={(e) => { this.props.onSelectOption(o.key); e.stopPropagation(); this.ReturnFocus(); }} id={`option_${i}`} key={o.key}>{o.value}</div>)}
            </div>}
        </div>
    }
    private checkKeyDown(key: string) {
        let newIndex = this.state.keySelectedIndex;
        if (key === "ArrowDown") {
            if (this.props.options.length > 0 && this.props.options.length > this.state.keySelectedIndex + 1)
                newIndex = this.state.keySelectedIndex < 0 ? 0 : this.state.keySelectedIndex + 1;
            if (newIndex % 8 == 0) {
                const optElement = document.getElementById(`option_${newIndex}`);
                const scrollHeight = optElement?.offsetHeight || 0;
                this.optionsRef.current?.scrollTo(0, newIndex * scrollHeight);
            }
        }
        if (key === "ArrowUp") {
            if (this.props.options.length > 0 && this.state.keySelectedIndex > 0)
                newIndex = this.state.keySelectedIndex - 1;
            if (newIndex % 8 == 7) {
                const optElement = document.getElementById(`option_${newIndex}`);
                const scrollHeight = optElement?.offsetHeight || 0;
                this.optionsRef.current?.scrollTo(0, (newIndex - 7) * scrollHeight);
            }
        }
        if (key === "Enter") {
            if (this.state.keySelectedIndex > -1) {
                const selectedKey = this.props.options[this.state.keySelectedIndex];
                this.props.onSelectOption(selectedKey.key);
                this.ReturnFocus();
                newIndex = -1;
            }
        }

        this.setState({ keySelectedIndex: newIndex })
    }


    handleClickOutside(event: any) {
        if (this.wrapperRef && !this.wrapperRef.current?.contains(event.target)) {
            this.setState({ showOptions: false })
        }
    }
}